import config from 'SRC/config/config.json'

export const languageVersions = config.languageVersions
